import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { ResponseUserMapping } from '@/schema'

const DEVTOOLS_NAME = 'UserMappingStore'

// User mapping store state and actions

interface UserMappingStore {
  // State
  editingUserMapping: ResponseUserMapping | null
  dialogOpen: boolean
  deletingUserMapping: ResponseUserMapping | null
  deleteDialogOpen: boolean

  // Actions
  setEditingUserMapping: (userMapping: ResponseUserMapping | null) => void
  clearEditingUserMapping: () => void
  setDialogOpen: (open: boolean) => void
  setDeletingUserMapping: (userMapping: ResponseUserMapping | null) => void
  clearDeletingUserMapping: () => void
  setDeleteDialogOpen: (open: boolean) => void
  reset: () => void
}

// Initial state
const initialState = {
  editingUserMapping: null as ResponseUserMapping | null,
  dialogOpen: false,
  deletingUserMapping: null as ResponseUserMapping | null,
  deleteDialogOpen: false,
}

export const useUserMappingStore = create<UserMappingStore>()(
  devtools(
    (set) => ({
      ...initialState,

      // Actions
      setEditingUserMapping: (userMapping) =>
        set({ editingUserMapping: userMapping }),
      clearEditingUserMapping: () => set({ editingUserMapping: null }),
      setDialogOpen: (open) => set({ dialogOpen: open }),
      setDeletingUserMapping: (userMapping) =>
        set({ deletingUserMapping: userMapping }),
      clearDeletingUserMapping: () => set({ deletingUserMapping: null }),
      setDeleteDialogOpen: (open) => set({ deleteDialogOpen: open }),
      reset: () => set({ ...initialState }),
    }),
    { name: DEVTOOLS_NAME }
  )
)
